// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1LWbD","clinicsSelect":"TableHeading_clinicsSelect__BSdAa"};